import { Router } from '@angular/router';
import { BusinessUser } from './../../../models/business-user.model';
import { MgService } from './../../../services/mg.service';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-user-responsive',
  templateUrl: './list-user-responsive.component.html',
  styleUrls: ['./list-user-responsive.component.scss']
})
export class ListUserResponsiveComponent implements OnInit {

  @Input() items: any;
  
  constructor(
    private api: MgService,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  public get apiService() {
    return this.api;
  }

  public editUser(user: BusinessUser){
    this.router.navigateByUrl(`/operador/usuarios/editar/${ user.id }`)
  }
}
